<template>
  <div>
    <template v-for="(item, index) in data">
      <div
        class="list"
        :key="index"
        @click="jumpDetail(item)"
        :clstag="`newscenter|keycount|detail-H5|link-id-${item.id}`"
        v-if="index < length"
      >
        <h3 :class="item.isMark ? 'font-red' : ''">
          <img
            v-if="item.pubTime >= todyTimer"
            src="@/assets/img-m/icon-new.png"
          />
          <span v-html="item.title"></span>
          <!-- <i class="top" v-if="item.top"></i> -->
          <!-- <img src="@/assets/img-m/icon-new.png" alt="" v-if="item.new" /> -->
        </h3>
        <h6>
          {{ item.pubTime | dataFilter }}<span>{{ item.classification }}</span>
        </h6>
      </div>
    </template>
  </div>
</template>

<script>
// import { getLang } from '@/utils'
import jumpDetail from '../mixin/jumpDetail'
export default {
  mixins: [jumpDetail],
  props: {
    data: Array,
    length: {
      type: Number,
      default: Number.MAX_VALUE
    }
  },
  data() {
    return {
      todyTimer: new Date().setHours(0, 0, 0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';
.list {
  padding: 0.3rem 0.05rem 0.4rem;
  border-bottom: 1px solid $borderColor;
  h3 {
    font-size: 0.32rem;
    color: #333;
    line-height: 0.48rem;
    @include ellipsisMultiline($number: 2);
    img {
      width: 0.7rem;
      margin-right: 0.08rem;
      vertical-align: middle;
    }
  }
  h6 {
    line-height: 0.24rem;
    font-size: 0.24rem;
    padding-top: 0.28rem;
    color: #999;
    span {
      margin-left: 0.4rem;
      padding: 0.03rem 0.08rem;
      font-size: 0.2rem;
      color: $themeColor;
      border: 1px solid $themeColor;
      border-radius: 0.1rem;
    }
  }
  .font-red {
    color: #e02020;
  }
}
</style>
